/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V2beta1Url
 */
export interface V2beta1Url {
  /**
   * URL of the pipeline version definition.
   * @type {string}
   * @memberof V2beta1Url
   */
  pipeline_url?: string;
}

/**
 * Check if a given object implements the V2beta1Url interface.
 */
export function instanceOfV2beta1Url(value: object): value is V2beta1Url {
  return true;
}

export function V2beta1UrlFromJSON(json: any): V2beta1Url {
  return V2beta1UrlFromJSONTyped(json, false);
}

export function V2beta1UrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): V2beta1Url {
  if (json == null) {
    return json;
  }
  return {
    pipeline_url: json['pipeline_url'] == null ? undefined : json['pipeline_url'],
  };
}

export function V2beta1UrlToJSON(json: any): V2beta1Url {
  return V2beta1UrlToJSONTyped(json, false);
}

export function V2beta1UrlToJSONTyped(
  value?: V2beta1Url | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline_url: value['pipeline_url'],
  };
}
